'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */
function hashFn(str) {
    var hash = 5381,
        i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

function getStars(count,isEmptyStar) {
    var string = '';
    var stringToAppend = isEmptyStar ? '<i class="fa fa-star-o"></i>' : '<i class="fa fa-star"></i>';
    for (var i = 0; i < count; i++) {
        string += stringToAppend;
    }
    return string;
}


module.exports = {
    init: function () {
        $('.product-review').each(function (index, review) {
            var pid_rating = $(review).data('rating');
            if (!pid_rating || ($(review).attr('data-rating-loaded'))){
                return;
            }
            // rating range from 2 - 5
            var rating = pid_rating;       
            var baseRating = rating !== 0 ? Math.floor(Number(rating) + 0.05) : '';            
            var emptyStarsCount = 5 - baseRating ;
            var halfStar = '<i class="fa fa-star-half-o"></i>';
            
            if (baseRating === 0){
                $('.rating', review).append(halfStar).append(getStars(4,true));
            } else if (rating >= 4.95 && rating <= 5.00){
                $('.rating', review).append(getStars(5,false));
            } else{
                $('.rating', review).append(getStars(baseRating,false));
                if ((rating -  baseRating) >= 0.45 && (rating -  baseRating) <= 0.94) { 
                    $('.rating', review).append(halfStar);
                    emptyStarsCount -= 1;
                }
                if(emptyStarsCount){
                    $('.rating', review).append(getStars(emptyStarsCount,true));
                }                
            }
            $(review).attr('data-rating-loaded',true);
        });
    }
};
